import { Flex, FormLabel, IconButton, Text } from '@chakra-ui/react';
import React from 'react';
import { Locale, MinusIcon, PlusIcon } from '../../shared';
import translation from './lib/translations';

const smsButtonsStyles = {
  h: 6,
  minW: 6,
  variant: 'ghost',
};

interface ISmsCounterProps {
  addPackage: () => void;
  minusPackage: () => void;
  summarySms: number;
  isDisableMinus: boolean;
  locale: Locale | string;
}

const SmsCounter: React.FC<ISmsCounterProps> = ({
  addPackage,
  minusPackage,
  summarySms,
  isDisableMinus,
  locale,
}) => {
  const { sms } = translation(locale);

  return (
    <Flex flexDir='column'>
      <FormLabel htmlFor='smsPackages'>{sms.label}</FormLabel>
      <Flex
        alignItems='center'
        bg='bg.pure'
        border='1px solid'
        borderColor='border.pure'
        borderRadius='md'
        gap='2xs'
        minH={10}
        px='xs'
        w='fit-content'
      >
        <IconButton
          aria-label={sms.minusLabel}
          aria-labelledby={sms.minusLabel}
          icon={
            <MinusIcon
              boxSize={4}
              color='icon.pure'
            />
          }
          isDisabled={isDisableMinus}
          onClick={minusPackage}
          {...smsButtonsStyles}
        />
        <Text>
          {summarySms} {sms.text}
        </Text>
        <IconButton
          aria-label={sms.plusLabel}
          aria-labelledby={sms.plusLabel}
          icon={
            <PlusIcon
              boxSize={4}
              color='icon.pure'
            />
          }
          onClick={addPackage}
          {...smsButtonsStyles}
        />
      </Flex>
    </Flex>
  );
};

export default SmsCounter;
